import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Icon from '@showclix-shared/Icon';
import InlineCouponModal from './InlineCouponModal';
import { useTranslation } from '../../../config/Translations';
import { hasCoupons } from '@b/checkout/selectors/event';

const InlineCoupon = () => {
  const { t } = useTranslation();
  const couponCode = useSelector((state) => state.coupon.code);
  const accentColor = useSelector((state) => state.ui.styleVars.GLOBAL__COLOR__ACCENT);
  const couponCanBeApplied = useSelector(hasCoupons);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => setIsModalOpen(false);
  const openModal = () => setIsModalOpen(true);

  if (!couponCanBeApplied) {
    return null;
  }

  return (
    <>
      <div className={classNames('checkout-form__section inline-coupon__root', { 'inline-coupon__root--applied': !!couponCode })}>
        <div className="form-card">
          <div className="form-card__header">
            <h4 className="form-card__heading">{t('checkout__promo_code')}</h4>
          </div>
          <div className="form-card__content">
            <div className="input">
              <label className="input__label">{t('checkout__promo_code')}</label>
              <button className="input__control" onMouseDown={openModal}>
                <Icon icon="icon-local_offer" color="#888888" />
                {!couponCode && <p>{t('checkout__add_promo_code')}</p>}
                {couponCode && <p>{t('checkout__promo_code_applied', { code: couponCode })}</p>}
                <Icon icon="icon-mode_edit" color={accentColor} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <InlineCouponModal open={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default InlineCoupon;
